try{self['workbox:sw:6.5.4']&&_()}catch(e){}// eslint-disable-line